/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Avatar, Box, FormControl, TextField, useTheme } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { usePaymentInputs } from "react-payment-inputs";
import Field from "../Field";
import ErrorMessage from "../ErrorMessage";
import useResponsive from "@/hooks/useResponsive";
import { formControlStyles, getInputStyles, iconCardStyles } from "./styles";
import { cardImages } from "./cardImages";

interface IProp {
  control: Control<any>;
}

const PaymentInputs: React.FC<IProp> = ({ control }) => {
  const {
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
  } = usePaymentInputs();

  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" gap={{ xs: 2, md: 3 }}>
      <Controller
        name="number"
        control={control}
        render={({ field, fieldState }) => (
          <FormControl
            component="label"
            error={!!fieldState.error}
            sx={formControlStyles}
          >
            <Box position="absolute" sx={iconCardStyles}>
              <Avatar {...getCardImageProps({ images: cardImages })} />
            </Box>
            <TextField
              {...field}
              inputProps={getCardNumberProps({})}
              sx={getInputStyles(isMobile, theme, true)}
            />
            {fieldState.error?.message && (
              <ErrorMessage message={fieldState.error.message} />
            )}
          </FormControl>
        )}
      />

      <Box display="flex" justifyContent="space-between" gap={2}>
        <Controller
          name="expiry"
          control={control}
          render={({ field, fieldState }) => (
            <FormControl
              component="label"
              error={!!fieldState.error}
              sx={formControlStyles}
            >
              <TextField
                {...field}
                inputProps={getExpiryDateProps({})}
                sx={getInputStyles(isMobile, theme)}
              />
              {fieldState.error?.message && (
                <ErrorMessage message={fieldState.error.message} />
              )}
            </FormControl>
          )}
        />
        <Controller
          name="cvc"
          control={control}
          render={({ field, fieldState }) => (
            <FormControl
              component="label"
              error={!!fieldState.error}
              sx={formControlStyles}
            >
              <TextField
                {...field}
                inputProps={{ ...getCVCProps({}), type: "password" }}
                sx={getInputStyles(isMobile, theme)}
              />
              {fieldState.error?.message && (
                <ErrorMessage message={fieldState.error.message} />
              )}
            </FormControl>
          )}
        />
      </Box>
      <Field
        name="cardholder"
        control={control}
        placeholder="Cardholder name"
      />
    </Box>
  );
};

export default PaymentInputs;
